<template v-if="masterUsps.length">
  <template v-for="(usp, index) in masterUsps" :key="index">
    <div v-if="usp.value" class="flex items-center font-bold">
      <svg class="mr-3 rotate-90 text-[color:var(--color-secondary)-500]" height="22" width="25">
        <use href="/static/images/veld-icon-bg.svg#main" />
      </svg>

      {{ usp.value }}
    </div>
  </template>
</template>

<script setup lang="ts">
import { computed } from "vue";
import type { Product, Property } from "@/core/api/graphql/types";

interface IProps {
  product: Product;
  master?: Product;
  model: {
    title?: string;
    hidden?: boolean;
  };
}

const props = defineProps<IProps>();

const masterUsps = computed<Property[]>(
  () => props.product?.masterVariation?.properties.filter((prop) => prop.name === "usps") || [],
);
</script>
